import { SelectInput, required, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { parameterValueTypeChoices } from '@/constants/ParameterValueTypes.js';
import { resetSubsetValuesDeep } from '@/helpers/parameter/parameterSubsets.js';

export const ParameterTypeInput = () => {
    const translate = useTranslate();
    const { setValue, getValues } = useFormContext();

    return (
        <SelectInput
            source='type'
            label={translate('resources.parameter.fields.type')}
            choices={parameterValueTypeChoices(translate)}
            validate={required(translate('common.validation.required'))}
            onChange={() => {
                setValue('value', '');
                resetSubsetValuesDeep(getValues('subsets'), 'subsets', setValue);
            }}
            fullWidth
        />
    );
};
